const initState = {
    addressFormats: {}
};

export const LOAD_ADDRESS_FORMATS = 'LOAD_ADDRESS_FORMATS';

export const setAddressFormats = (data) => {
    return { type: LOAD_ADDRESS_FORMATS, payload: data }
};

export default (state = initState, action) => {
    switch (action.type) {
        case LOAD_ADDRESS_FORMATS:
            return { ...state, addressFormats: action.payload };
        default:
            return state
    }
}